/* eslint-disable no-dupe-keys */
export default {
  top_up_statistics: {
    titles: {
      // 统计面板
      overview: '综合概览',
      dashboard: '充值统计面板',
      // 按时间分组统计
      time_group_statistics: '按时间趋势统计',
      export_time_group_statistics: '按时间统计的充值数据',
      statistics_top_ups_amount: '充值金额统计',
      statistics_top_ups_count: '充值数统计',
      statistics_avg_top_up_amount: '平均每笔金额',
      statistics_users_count: '用户数',
      // 按属性分组统计
      prop_group_statistics: '按属性分组统计',
      export_prop_group_statistics: '按属性统计的充值数据'
    },
    legends: {
      top_ups_amount: '充值金额(元)',
      top_ups_count: '充值数(次)',
      avg_top_up_amount: '平均每笔金额(元)',
      users_count: '用户数'
    },
    labels: {
      group_by: '统计项',
      top_up_created_at: '充值时间',
      ignore_offline_pay: '充值方式',
      user: '用户'
    },
    btn: {
      more: '查看更多'
    },
    // enum
    group_types: {
      user_tag: '按用户标签',
      payment_type: '按支付类型'
    },
    offline_payments: {
      true: '忽略平台充值',
      false: '全部充值方式'
    }
  }
}
